export const tag = {
    namespaced: true,
    state: {
        tags: [],
        isLoading: false,
        listeners: []
    },
    mutations: {
        startToLoad(state) {
            state.isLoading = true;
        },
        setTags(state, tags) {
            if (tags != null) {
                state.tags = tags;

                let listeners = state.listeners;
                for (let i = 0; i < listeners.length; i++) {
                    listeners[i]();
                }
            }
        },
        addListener(state, listener) {
            if (listener != null) {
                state.listeners.push(listener);
            }
        }
    },
    methods: {
        updateForm(state) {
            let listeners = state.listeners;
            for (let i = 0; i < listeners.length; i++) {
                listeners[i]();
            }
        }
    }
}